import React, { useState } from 'react';
import { Modal } from './Modal';
export const NewFooter = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  return <>
      <footer className="w-full py-8 px-4 border-t border-gray-200 bg-white" data-id="element-42">
        <div className="container mx-auto max-w-6xl" data-id="element-43">
          <div className="text-center space-y-3" data-id="element-44">
            <p className="text-gray-700 text-sm" data-id="element-45">
              © 2025 Masterclass de Crédito en USA — DanyCredit LLC. All rights
              reserved.
            </p>
            <p className="text-gray-700 text-sm" data-id="element-46">
              Contact Email:{' '}
              <a href="mailto:info@danycredit.com" className="text-[#7A3CF3] hover:underline" data-id="element-47">
                info@danycredit.com
              </a>
            </p>
            <div className="flex justify-center gap-4 flex-wrap text-sm" data-id="element-48">
              <button onClick={() => setShowPrivacyModal(true)} className="text-gray-600 hover:text-[#7A3CF3] transition-colors" data-id="element-49">
                Política de Privacidad
              </button>
              <span className="text-gray-400" data-id="element-50">|</span>
              <button onClick={() => setShowTermsModal(true)} className="text-gray-600 hover:text-[#7A3CF3] transition-colors" data-id="element-51">
                Términos y Condiciones
              </button>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-6 pt-6" data-id="element-52">
            <div className="text-gray-500 text-xs leading-relaxed max-w-4xl mx-auto space-y-2" data-id="element-53">
              <p data-id="element-54">
                This site is not affiliated with or endorsed by Facebook™ or
                Meta Platforms, Inc.
              </p>
              <p data-id="element-55">
                DanyCredit LLC provides educational content only. No guarantees
                of specific results. Use of information is at participant's own
                responsibility.
              </p>
            </div>
          </div>
        </div>
      </footer>
      <Modal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} title="Política de Privacidad — DanyCredit LLC" data-id="element-56">
        <div className="space-y-4 text-gray-700 text-sm leading-relaxed" data-id="element-57">
          <p data-id="element-58">
            Esta Política de Privacidad explica cómo recopilamos, utilizamos y
            protegemos la información que voluntariamente nos proporcionas al
            registrarte o utilizar cualquiera de nuestros servicios, formularios
            o plataformas digitales. El uso de este sitio web implica tu
            aceptación de esta política.
          </p>
          <div data-id="element-59">
            <h3 className="font-bold text-black mb-2" data-id="element-60">
              1. Información que recopilamos
            </h3>
            <p className="mb-2" data-id="element-61">
              Recopilamos información personal que tú mismo proporcionas, como:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-62">
              <li data-id="element-63">Nombre</li>
              <li data-id="element-64">Correo electrónico</li>
              <li data-id="element-65">Número de teléfono</li>
              <li data-id="element-66">Información enviada voluntariamente en formularios</li>
            </ul>
            <p className="mt-2" data-id="element-67">
              También recopilamos datos no personales como:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-68">
              <li data-id="element-69">Dirección IP</li>
              <li data-id="element-70">Tipo de dispositivo</li>
              <li data-id="element-71">Páginas visitadas</li>
              <li data-id="element-72">Comportamientos dentro del sitio</li>
            </ul>
            <p className="mt-2" data-id="element-73">
              Esto se utiliza únicamente para fines analíticos y de
              funcionamiento del sitio.
            </p>
          </div>
          <div data-id="element-74">
            <h3 className="font-bold text-black mb-2" data-id="element-75">
              2. Cómo utilizamos tu información
            </h3>
            <p className="mb-2" data-id="element-76">La información puede utilizarse para:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-77">
              <li data-id="element-78">
                Enviar confirmaciones de registro y comunicaciones relacionadas
                al evento
              </li>
              <li data-id="element-79">Responder consultas</li>
              <li data-id="element-80">Mejorar la experiencia del usuario</li>
              <li data-id="element-81">
                Enviar contenido educativo relacionado a crédito y finanzas (no
                spam)
              </li>
            </ul>
            <p className="mt-2" data-id="element-82">
              No vendemos, alquilamos ni compartimos tu información con
              terceros.
            </p>
          </div>
          <div data-id="element-83">
            <h3 className="font-bold text-black mb-2" data-id="element-84">
              3. Cookies y tecnologías similares
            </h3>
            <p data-id="element-85">
              Utilizamos cookies para mejorar la funcionalidad, medir resultados
              y optimizar la experiencia del usuario. Puedes desactivarlas desde
              tu navegador si lo deseas.
            </p>
          </div>
          <div data-id="element-86">
            <h3 className="font-bold text-black mb-2" data-id="element-87">4. Seguridad</h3>
            <p data-id="element-88">
              Implementamos medidas técnicas razonables para proteger tu
              información. No obstante, ningún sistema digital es 100% seguro y
              no podemos garantizar seguridad absoluta.
            </p>
          </div>
          <div data-id="element-89">
            <h3 className="font-bold text-black mb-2" data-id="element-90">5. Enlaces externos</h3>
            <p data-id="element-91">
              Nuestro sitio puede contener enlaces a páginas externas. No somos
              responsables por las políticas o prácticas de dichos sitios.
            </p>
          </div>
          <div data-id="element-92">
            <h3 className="font-bold text-black mb-2" data-id="element-93">
              6. Cambios a esta política
            </h3>
            <p data-id="element-94">
              Podemos actualizar esta Política de Privacidad en cualquier
              momento. La versión más reciente siempre estará disponible en esta
              página.
            </p>
          </div>
          <div data-id="element-95">
            <h3 className="font-bold text-black mb-2" data-id="element-96">7. Contacto</h3>
            <p data-id="element-97">Para cualquier consulta relacionada con esta política:</p>
            <p className="mt-1" data-id="element-98">
              Email:{' '}
              <a href="mailto:info@danycredit.com" className="text-[#7A3CF3] hover:underline" data-id="element-99">
                info@danycredit.com
              </a>
            </p>
          </div>
        </div>
      </Modal>
      <Modal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} title="Términos y Condiciones — DanyCredit LLC" data-id="element-100">
        <div className="space-y-4 text-gray-700 text-sm leading-relaxed" data-id="element-101">
          <p data-id="element-102">
            Al acceder o utilizar este sitio web y registrarte en cualquiera de
            nuestros entrenamientos o eventos, aceptas los siguientes términos y
            condiciones.
          </p>
          <div data-id="element-103">
            <h3 className="font-bold text-black mb-2" data-id="element-104">
              1. Propósito educativo
            </h3>
            <p data-id="element-105">
              Todo el contenido ofrecido (incluyendo clases, materiales,
              ejemplos y explicaciones) es exclusivamente con fines educativos e
              informativos. No garantizamos resultados específicos, aumentos de
              puntaje, aprobaciones de crédito ni decisiones de instituciones
              financieras. Cada caso crediticio es diferente.
            </p>
          </div>
          <div data-id="element-106">
            <h3 className="font-bold text-black mb-2" data-id="element-107">
              2. No es asesoría legal, financiera ni fiscal
            </h3>
            <p data-id="element-108">
              La información compartida no debe interpretarse como asesoría
              profesional. Siempre consulta con un profesional certificado antes
              de tomar decisiones relacionadas con tu crédito o finanzas.
            </p>
          </div>
          <div data-id="element-109">
            <h3 className="font-bold text-black mb-2" data-id="element-110">3. Pagos y reembolsos</h3>
            <p data-id="element-111">
              Todas las compras son finales y no reembolsables, ya que el acceso
              al contenido es inmediato. No ofrecemos cancelaciones ni
              devoluciones bajo ninguna circunstancia.
            </p>
          </div>
          <div data-id="element-112">
            <h3 className="font-bold text-black mb-2" data-id="element-113">4. Uso permitido</h3>
            <p data-id="element-114">
              No puedes copiar, distribuir, vender o compartir el contenido,
              materiales, grabaciones o recursos proporcionados. El acceso es
              personal e intransferible.
            </p>
          </div>
          <div data-id="element-115">
            <h3 className="font-bold text-black mb-2" data-id="element-116">
              5. Limitación de responsabilidad
            </h3>
            <p className="mb-2" data-id="element-117">No somos responsables por:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-118">
              <li data-id="element-119">Decisiones que tomes basadas en el contenido</li>
              <li data-id="element-120">Cambios en políticas de bancos o burós</li>
              <li data-id="element-121">Resultados que dependan de tu situación individual</li>
            </ul>
            <p className="mt-2" data-id="element-122">Tu participación es bajo tu propio riesgo.</p>
          </div>
          <div data-id="element-123">
            <h3 className="font-bold text-black mb-2" data-id="element-124">
              6. Propiedad intelectual
            </h3>
            <p data-id="element-125">
              Todos los textos, imágenes, gráficos, videos y materiales
              pertenecen a DanyCredit LLC.
            </p>
          </div>
          <div data-id="element-126">
            <h3 className="font-bold text-black mb-2" data-id="element-127">7. Modificaciones</h3>
            <p data-id="element-128">
              Podemos actualizar estos términos en cualquier momento. La versión
              más reciente estará disponible en esta página.
            </p>
          </div>
          <div data-id="element-129">
            <h3 className="font-bold text-black mb-2" data-id="element-130">8. Contacto</h3>
            <p data-id="element-131">Para consultas sobre estos términos:</p>
            <p className="mt-1" data-id="element-132">
              Email:{' '}
              <a href="mailto:info@danycredit.com" className="text-[#7A3CF3] hover:underline" data-id="element-133">
                info@danycredit.com
              </a>
            </p>
          </div>
        </div>
      </Modal>
    </>;
};